import * as React from 'react';
import useScript from 'utils/useScript';
import { getAbsoluteHost } from 'utils/commonFunc';

export default function JMuxerVideo(props) {
    const {
        url, fps
    } = props;

    const videoRef = React.useRef(null);
    const [scriptLoaded] = useScript(getAbsoluteHost("/scripts/JMuxer.min.js"));

    React.useEffect(() => {
        if (!scriptLoaded)
            return;

        if (!url)
            return;

        const jmuxer = new window.JMuxer({
            node: videoRef.current,
            mode: 'video',
            flushingTime: 500,
            fps: fps ?? 30,
            //debug: true,
        });

        const ws = new WebSocket(url);
        ws.binaryType = 'arraybuffer';
        ws.addEventListener('message', function (message) {
            if (message.data instanceof ArrayBuffer) {
                jmuxer.feed({
                    video: new Uint8Array(message.data)
                });
            } else {
                console.log(`WebSocket Message ${message.data}`);
            }
        });

        ws.addEventListener('error', function (e) {
            switch (e.currentTarget?.readyState) {
                case 0:
                    console.log('WebSocket Error CONNECTING');
                    break;
                case 1:
                    console.log('WebSocket Error CLOSING');
                    break;
                case 2:
                    console.log('WebSocket Error CLOSING');
                    break;
                case 3:
                    console.log('WebSocket Error CLOSED');
                    break;
                default:
                    console.log('WebSocket Error');
            }
        });

        return () => {
            if (ws) {
                ws.close();
            }

            if (jmuxer) {
                jmuxer.destroy();
            }
        }
    }, [url, scriptLoaded]);

    const childrenProps = () => {
        const copy = { ...props }
        delete copy.url;
        return copy
    }

    return (
        <video ref={videoRef} autoPlay muted style={{backgroundColor:'black', width:'100%', height:'100%'}} {...childrenProps()} />
    )
}